import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { HttpService } from '../../http.service';
import { environment } from '../../../environments/environment';
import { Distributor } from '../../models/distributor';

@Injectable()
export class DistributorsService extends BaseService
{
	private http: HttpService;
	private api: string;

	constructor(http: HttpService)
	{
		super();

		this.http = http;
		this.api = environment.api_url;
	}

	public getDistributors(): Promise<Distributor[]>
	{
		return this.http
			.get(this.api + 'distributors')
			.toPromise()
			.then(response => response.json().data as Distributor[])
			.catch(this.handleError);
	}

	public getDistributorById(id: number): Promise<Distributor>
	{
		return this.http
			.get(this.api + 'distributors/' + id)
			.toPromise()
			.then(response => response.json().data as Distributor)
			.catch(this.handleError);
	}

	public removeDistributor(id: number): Promise<Response>
	{
		return this.http
			.delete(this.api + 'distributors/' + id)
			.toPromise()
			.then(response => response)
			.catch(this.handleError);
	}

	public updateDistributor(distributor: Distributor): Promise<Distributor>
	{
		return this.http
			.put(this.api + 'distributors/' + distributor.id, JSON.stringify(distributor))
			.toPromise()
			.then(response => response.json().data as Distributor)
			.catch(this.handleError);
	}

	public storeDistributor(distributor: Distributor): Promise<Distributor>
	{
		return this.http
			.post(this.api + 'distributors', JSON.stringify(distributor))
			.toPromise()
			.then(response => response.json().data as Distributor)
			.catch(this.handleError);
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/services/distributors.service.ts